module.exports = __webpack_public_path__ + "img/7-min.ded12ade.jpg";